import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import { Refund } from './refund';
import { Toast, Modal, Button, Picker, List, WhiteSpace } from 'antd-mobile';
import * as services from '../../projects/services';
import CountDown from '../../../components/countDown';
import { createBrowserHistory } from "history";
import './style.less';


const history = createBrowserHistory();
let page = 1;
const rows = 5;
let total = 0;
function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}
let dicList = [
    { label: '我不想买了', value: 0 },
    { label: '支付不成功', value: 1 },
    { label: '其他渠道价格更低', value: 2 },
    { label: '更换体检套餐', value: 3 },
    { label: '重复下单', value: 4 },
];

export default class OrderList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parameter: { page: page, rows: rows, Title: '' },
            order: [],
            dicList: [],
            orderdetail: [],
            totalMilliseconds: 0,
            detail: [],
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            colorValue: 0,
            allprice: 0,
            canleid: 0,
            detailid: 0,
            projectlist: [],
            msg: ""
        }
        this.GetOrderListpage = this.GetOrderListpage.bind(this);
    }
    componentDidMount() {
        services.GetOrderListpage(this.state.parameter, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                total = data.result.order.total;
                this.setState(
                    {
                        order: data.result.order.rows,
                        dicList: data.result.dic.dicList,
                        orderdetail: data.result.detail,
                        totalMilliseconds: data.result.totalMilliseconds

                    },
                    () => {

                    }
                );
            } else {
                Toast.offline(data.message);
            }

        })
        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total / rows >= page) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }

            timeCount = setTimeout(callback, 50);
        }.bind(this), false);

    }
    GetOrderListpage = () => {
        services.GetOrderListpage(this.state.parameter, '').then(data => {
            if (data.status === 0) {
                total = data.result.order.total;
                this.setState(
                    {
                        order: data.result.order.rows,
                        dicList: data.result.dic.dicList,
                        orderdetail: data.result.detail,
                        totalMilliseconds: data.result.totalMilliseconds
                    },
                    () => {

                    }
                );
            } else {
                Toast.offline(data.message);
            }

        })
    }
    //再次加载
    loadMoreDataFn = (page) => {
        let parameter = this.state.parameter;
        parameter.page = page;
        this.setState({
            parameter: parameter,
        });
        services.GetOrderListpage(this.state.parameter, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                total = data.result.order.total;
                this.setState({
                    order: this.state.order.concat(data.result.order.rows),
                    dicList: this.state.dicList.concat(data.result.dic.dicList),
                    orderdetail: this.state.orderdetail.concat(data.result.detail),
                    totalMilliseconds: data.result.totalMilliseconds
                });
            } else {
                Toast.offline(data.message);
            }
        })
    }
    showModal = (key, value) => (e) => {
        e.preventDefault(); // 修复 Android 上点击穿透
        this.setState({
            [key]: true,
        });
        if (key === 'modal2') {
            this.setState({ canleid: value });
        } else {
            let item = this.state.orderdetail.filter(p => p.orderid === value);
            let price = 0;
            item.forEach(function (value) {
                if (parseInt(value.buymoney) === 0) {
                    price += parseFloat(value.price) * parseFloat(value.buycount)
                } else {
                    price += parseFloat(value.buymoney) * parseFloat(value.buycount)
                }


            });
            this.setState({
                detail: item, allprice: price
            });
        }

    }
    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
            e.preventDefault();
        }
    }
    onChangeColor = (color) => {
        this.setState({
            colorValue: color,
        });
    };
    findstyle = (code) => {

        if (this.state.dicList.length > 0) {
            let item = this.state.dicList.find(p => parseInt(p.code) === code);
            return item.name;
        } else {
            return '';
        }
    }
    findnum = (code) => {
        if (this.state.orderdetail.length > 0) {
            let item = this.state.orderdetail.filter(p => p.orderid === code);
            return item.length;
        } else {
            return 0;
        }
    }
    findprice = (code) => {
        if (this.state.orderdetail.length > 0) {
            let item = this.state.orderdetail.filter(p => p.orderid === code);
            let price = 0;
            item.forEach(function (value) {
                if (parseInt(value.buymoney) === 0) {
                    price += parseFloat(value.price) * parseFloat(value.buycount)
                } else {
                    price += parseFloat(value.buymoney) * parseFloat(value.buycount)
                }

            });
            return price;
        } else {
            return 0;
        }
    }

    canleorder = (e) => {
        if (this.state.colorValue === 0) {
            Toast.offline('请选择订单取消原因', 1);
            return false;
        }
        let parameter = { orderid: this.state.canleid, reason: dicList[this.state.colorValue].label };
        services.CancelOrder(parameter, '正在取消，请稍后').then(data => {
            if (data.status === 0) {
                services.GetOrderListpage(this.state.parameter, '').then(data => {
                    if (data.status === 0) {
                        this.setState(
                            {
                                order: data.result.order.rows,
                                dicList: data.result.dic.dicList,
                                orderdetail: data.result.detail
                            },
                            () => {

                            }
                        );
                    } else {
                        Toast.offline(data.message);
                    }

                })
            } else {
                Toast.offline(data.message);
            }

        });
        this.onClose('modal2')();
    }
    payClick = (orderid, e) => {
        history.push(`/pay/${orderid}`);
        history.go();
    }
    mrefund = (detailid, e) => {
        this.setState({
            modal3: true, detailid: detailid
        });
    }
    gopackage = (data, e) => {
        history.push(`/package/item/${data.opid}/${!!data.title ? data.title : '测试套餐'}/${data.realprice}`);
        history.go();
    }
    render() {
        const { order, orderdetail, totalMilliseconds } = this.state;
        return (
            <div className="order">
                <CommonlyHeadMembers barname='订单管理' />
                {
                    order.lenth <= 0 || !!order === false ? <div className="nothing">
                        <img alt='' src={require('../../../res/images/zwsj.png')} />
                        <p>您还没有订单</p></div> :
                        order.map((data, index) => (
                            <div key={index}><WhiteSpace />

                                <div className="orderList"  >

                                    <div className="ordertop">
                                        <div className="tname">订单号:<span className="tipa">{data.orderno}</span><span className="tipb">({this.findstyle(data.orderstatus)})</span></div>
                                        <div className="cname">{data.mcName}</div>
                                    </div>
                                    {
                                        orderdetail.length === 0 ? '' :
                                            orderdetail.map((data2, index2) => (
                                                data.orderid === data2.orderid ?
                                                    <div className="ordercen" key={index2}>
                                                        <div className="cenimg" onClick={this.gopackage.bind(this, data2)} >
                                                            <img src={data2.picPath === 0 || data2.picPath === null ? require('../../../res/images/zw.jpg') : data2.picPath} alt="" />
                                                        </div>
                                                        <div className="text"><div className="name" onClick={this.gopackage.bind(this, data2)} >{data2.title}</div>
                                                            {
                                                                data.orderstatus === 2 && data2.codeCount > 0 ?
                                                                    <div className="hprice">{parseInt(data2.buymoney) === 0 ? data2.price : data2.buymoney}*{data2.buycount}
                                                                        <Button inline className="bc" onClick={() => {
                                                                            history.push('/members/orderment/0');
                                                                            history.go();

                                                                        }}  >体检预约</Button>
                                                                        <Button inline className="bb" onClick={this.mrefund.bind(this, data2.detailid)}  >退款</Button>
                                                                    </div>
                                                                    : <div className="hprice">{parseInt(data2.buymoney) === 0 ? data2.price : data2.buymoney}*{data2.buycount}</div>
                                                            }
                                                        </div>
                                                    </div>
                                                    : ''
                                            ))
                                    }
                                    <div className="orderfooter">
                                        {
                                            data.isclose === 0 && !!data.ispay === false && !!totalMilliseconds
                                                ?
                                                <div className="footera">
                                                    支付剩余时间：<CountDown endTime={totalMilliseconds} /></div>
                                                : ''
                                        }
                                        <div className="footera"><span className="htext">共{this.findnum(data.orderid)}件，总价：</span><span className="hprice">{this.findprice(data.orderid)}</span><Button inline className="ba" onClick={this.showModal('modal1', data.orderid)} >查看详情</Button></div>
                                        {
                                            data.orderstatus === 0 ?
                                                <div className="footera"><Button inline className="bb" onClick={this.showModal('modal2', data.orderid)}  >取消订单</Button><Button inline className="bc" onClick={this.payClick.bind(this, data.orderid)}   >付款</Button></div>
                                                : ''

                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                }
                <div ref="wrapper"></div>
                <Modal
                    visible={this.state.modal1}
                    transparent
                    closable={true}
                    maskClosable={true}
                    onClose={this.onClose('modal1')}
                    title="订单详情  "
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    afterClose={() => { }}
                >
                    <table className="ordertable">
                        <tbody>
                            <tr>
                                <th>套餐名称</th>
                                <th>价格（元）</th>
                                <th>数量（张）</th>
                                <th>总价（元）</th>
                            </tr>
                            {
                                this.state.detail.length <= 0 ? '' :
                                    this.state.detail.map((data3, index3) => (
                                        <tr key={index3}>
                                            <td>{data3.title}</td>
                                            <td>{data3.buymoney}</td>
                                            <td>{data3.buycount}</td>
                                            <td className="hprice">{parseFloat(data3.buymoney) * parseFloat(data3.buycount)}</td>
                                        </tr>
                                    ))
                            }
                            <tr>
                                <td colSpan="4" className="foot">订单总金额：<span className="hprice">￥{this.state.allprice}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </Modal>

                <Modal
                    visible={this.state.modal2}
                    transparent
                    closable={true}
                    maskClosable={true}
                    onClose={this.onClose('modal2')}
                    title="订单取消申请 "
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    afterClose={() => { }}
                    footer={[{ text: '暂不取消', onPress: () => { this.onClose('modal2')(); } },
                    { text: '确定取消', onPress: () => { this.canleorder() } }
                    ]}
                >
                    <div className="modalqx" >
                        <div className="modaltishi">
                            <span className="yuan"><div className="icon-info"><span>!</span></div></span>
                            <div className="txt">
                                <span>您确定要取消该订单吗？</span>
                                <span className="colorg">提示：取消订单后，不能恢复。</span>
                            </div>
                        </div>
                        <Picker
                            data={dicList}
                            value={this.state.colorValue}
                            cols={1}
                            onChange={this.onChangeColor}
                            title='请选择取消原因'
                            extra="请选择取消原因(必选)"
                        >
                            <List.Item >取消原因:</List.Item>
                        </Picker>
                    </div>
                </Modal>

                <Modal
                    className="refundMoadl"
                    visible={this.state.modal3}
                    transparent
                    closable={true}
                    maskClosable={true}
                    onClose={this.onClose('modal3')}
                    title="订单退款申请"
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    afterClose={() => { }}
                >
                    <Refund detailid={this.state.detailid} onClose={this.onClose('modal3')} GetOrderListpage={this.GetOrderListpage} />
                </Modal>
                <Modal
                    visible={this.state.modal4}
                    transparent
                    closable={true}
                    maskClosable={true}
                    onClose={this.onClose('modal4')}
                    title="自定义套餐"
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    afterClose={() => { }}
                >
                    <table className="ordertable">
                        <tbody>
                            <tr>
                                <th>项目名称</th>
                                <th>价格（元）</th>
                            </tr>
                            {
                                this.state.projectlist.length <= 0 ? '' :
                                    this.state.projectlist.map((data3, index3) => (
                                        <tr key={index3}>
                                            <td>1</td>
                                            <td>2</td>
                                        </tr>
                                    ))
                            }
                            <tr>
                                <td colSpan="2" className="foot">套餐总金额：<span className="hprice">￥1111</span></td>
                            </tr>
                        </tbody>
                    </table>
                </Modal>

            </div>
        )
    }

}